import request from '../utils/request'

export const meditation_details=(unit_id)=>{
    return request({
        url:'/client/meditation_details',
        method:'post',
        data:{
            unit_id
        }
    })
}
export const ali_getVideo=(videoId)=>{
    return request({
        url:'/client/ali_getVideo',
        method:'post',
        data:{
            videoId
        }
    })
}
export const add_train=(phone,start_time,end_time,type,name)=>{
    return request({
        url:'/client/add_train',
        method:'post',
        data:{
            phone,
            start_time,
            end_time,
            type,
            name
        }
    })
}
export const train_ln=(phone)=>{
    return request({
        url:'/client/train_ln',
        method:'post',
        data:{
            phone
        }
    })
}
export const train_info=(id)=>{
    return request({
        url:'/client/train_info',
        method:'post',
        data:{
            id
        }
    })
}
export const train_report=(phone,start_time,end_time)=>{
    return request({
        url:'/client/train_report',
        method:'post',
        data:{
            phone,
            start_time,
            end_time,
        }
    })
}
export const test_item=(id)=>{
    return request({
        url:'/client/test_item',
        method:'post',
        data:{
            id
        }
    })
}
export const add_test=(phone,end_time,type,name,ans,dem_src,evaluate)=>{
    return request({
        url:'/client/add_test',
        method:'post',
        data:{
            phone,
            end_time,
            type,
            name,
            ans,
            dem_src,
            evaluate
        }
    })
}
export const test_report=(phone,id)=>{
    return request({
        url:'/client/test_report',
        method:'post',
        data:{
            phone,
            id
        }
    })
}


